import { Star } from "lucide-react";

export function Stars({ rating = 0, size = 13, className = "" }) {
  return (
    <div className={`flex items-center gap-0.5 ${className}`} aria-label={`${rating} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          size={size}
          strokeWidth={1.5}
          className={n <= Math.round(rating) ? "fill-gold text-gold" : "text-sand"}
        />
      ))}
    </div>
  );
}
